import { ReactNode, createContext, useContext } from "react";
import useWaiverForm, { UseWaiverFormProps } from "./useWaiverForm";

export type WaiverContextType = ReturnType<typeof useWaiverForm>;

export const WaiverContext = createContext<WaiverContextType>(
  {} as WaiverContextType
);

export interface WaiverProviderProps extends UseWaiverFormProps {
  children: ReactNode;
}

export default function WaiverProvider({
  children,
  id,
  afterSave,
}: WaiverProviderProps) {
  const value = useWaiverForm({ id, afterSave });

  return (
    <WaiverContext.Provider value={value}>{children}</WaiverContext.Provider>
  );
}

export const useWaiverState = () => {
  const ctx = useContext(WaiverContext);

  if (!ctx) {
    throw new Error("You need to wrap your app with WaiverProvider");
  }

  return ctx;
};
